'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    placeholder: 'Selezionare il tempo'
};
exports['default'] = locale;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/time-picker/locale/it_IT.js
// module id = 602
// module chunks = 0